import isNil from 'lodash-es/isNil'
import { ReactNode } from 'react'
import { styled } from 'styled-components'

interface zIndexesByState {
  default: number
  selected?: number
  focused?: number
  hovered?: number
}
interface CustomMarkerProps {
  lat: number
  lng: number
  children: ReactNode
  size: number
  onClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  zIndexes?: zIndexesByState
  isSelected?: boolean
  isFocused?: boolean
  /** Only for marker positioning - apply a negative margin top / 2 */
  height?: number
  isInteractive?: boolean
}

const CustomBox = styled(Box)<{
  $zIndexes?: zIndexesByState
  $isSelected?: boolean
  $isFocused?: boolean
}>`
  z-index: ${(p) =>
    !isNil(p.$zIndexes?.focused) && p.$isFocused
      ? p.$zIndexes.focused
      : !isNil(p.$zIndexes?.selected) && p.$isSelected
        ? p.$zIndexes.selected
        : (p.$zIndexes?.default ?? 1)};

  &:hover {
    z-index: ${(p) =>
      !isNil(p.$zIndexes?.hovered) ? p.$zIndexes.hovered : (p.$zIndexes?.default ?? 1)};
  }
`

const CustomMarker: FC<CustomMarkerProps> = ({
  size,
  onMouseEnter,
  onMouseLeave,
  onClick,
  children,
  zIndexes,
  height = size,
  isSelected,
  isFocused,
  isInteractive = false
}) => {
  return (
    <CustomBox
      $mt={-height}
      $ml={-size / 2}
      $width={size}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={
        !isNil(onClick)
          ? (e) => {
              e.stopPropagation()
              onClick()
            }
          : undefined
      }
      $zIndexes={zIndexes}
      $isSelected={isSelected}
      $isFocused={isFocused}
      $position='relative'
      $cursor={isInteractive ? 'pointer' : 'default'}
    >
      {children}
    </CustomBox>
  )
}

export default CustomMarker
